import  Simplex from "perlin-simplex";
export default class Boid {


    static getNoiseScale () {
        return 5; //larger means less change
    }

    constructor(x, y, el) {
        this.position = { x, y };
        this.velocity = { x: Math.random() - 0.5, y: Math.random() - 0.5 };
        this.speed = 1 + Math.random() * 3;
        this.currentAngle = null;
        this.viewRadius = 150;
        this.noiseScale = Boid.getNoiseScale();
        this.angleDegOffset = 135;

        this.angleOffset = Math.random() * Math.PI * 2;
        this.el = el;
        this.simplex = Boid.createNoise();

        this.alpha = 0;
        this.alphaSpeed = 0.005 + Math.random() * 0.005
        this.setPosition();

        document.addEventListener("keydown", (e) =>
        {
            if (e.key === "1")
            {
                this.angleDegOffset = 0;
            }
            else if (e.key === "2")
            {
                this.angleDegOffset =22.5 ;
            }
            else if (e.key === "3")
            {
                this.angleDegOffset =45 ;
            }
            else if (e.key === "4")
            {
                this.angleDegOffset =67.5 ;
            }
            else if (e.key === "5")
            {
                this.angleDegOffset =90 ;
            }
            else if (e.key === "6")
            {
                this.angleDegOffset =112.5 ;
            }
            else if (e.key === "7")
            {
                this.angleDegOffset =135 ;
            }
            else if (e.key === "8")
            {
                this.angleDegOffset =157.5 ;
            }
            else if (e.key === "9")
            {
                this.angleDegOffset =180 ;
            }
            else if (e.key === "0")
            {
                this.angleDegOffset =202.5 ;
            }
            else if (e.key === "-")
            {
                this.angleDegOffset =225 ;
            }
            else if (e.key === "=")
            {
                this.angleDegOffset =247.5 ;
            }
            else if (e.key === "Backspace")
            {
                this.angleDegOffset =270 ;
            }
            else if (e.key === "Tab")
            {
                this.angleDegOffset =292.5 ;
            }
            else if (e.key === "q")
            {
                this.angleDegOffset =315 ;
            }
            else if (e.key === "w")
            {
                this.angleDegOffset =337.5 ;
            }
            else if (e.key === "e")
            {
                this.angleDegOffset =360 ;
            }




        })
    }

    static createNoise ()
    {
        let number = Math.random();
        return new Simplex({
                               random: () => number

                           });
    }
    getNoise ()
    {
        return this.simplex;
    }
    random ()
    {
        return {
            random: () => Math.random() * 0xFFFFFF << 0
        };
    }
    update(boids, noise) {
        let alignment = { x: 0, y: 0 };
        let cohesion = { x: 0, y: 0 };
        let separation = { x: 0, y: 0 };
        let total = 0;



        // for (let boid of boids) {
        //     let distance = this.distance(boid.position, this.position);
        //     if (boid !== this && distance < this.viewRadius) {
        //         alignment.x += boid.velocity.x;
        //         alignment.y += boid.velocity.y;
        //         cohesion.x += boid.position.x;
        //         cohesion.y += boid.position.y;
        //
        //         if (distance < this.viewRadius / 2) {
        //             separation.x -= (boid.position.x - this.position.x) * 2;
        //             separation.y -= (boid.position.y - this.position.y) * 2;
        //
        //             boid.velocity.x *= 1.2;
        //             boid.velocity.y *= 1.2;
        //
        //             this.angleDegOffset += 5;
        //         }
        //         total++;
        //     }
        // }
        //
        // if (total > 0) {
        //     alignment.x = alignment.x / total;
        //     alignment.y = alignment.y / total;
        //     cohesion.x = (cohesion.x / total - this.position.x) / 100;
        //     cohesion.y = (cohesion.y / total - this.position.y) / 100;
        //     separation.x /= total;
        //     separation.y /= total;
        //     this.simplex = Boid.createNoise();
        //
        // }

        let x = Math.round(this.position.x / this.noiseScale);
        let y = Math.round(this.position.y/ this.noiseScale);
        let noiseValue = this.simplex.noise(x, y);


        let noiseAngle = noiseValue * Math.PI * 2;// + this.angleOffset;

        //noiseAngle in deg
        let noiseAngleDeg = noiseAngle * 180 / Math.PI;

        //this.angleOffset += Math.PI / 180;

        //let roundedTo = this.angleDegOffset * Math.PI / 180;

        //round to nearest 10 radians
        //noiseAngle = Math.round(noiseAngle / roundedTo) * roundedTo;



        //convert rad to deg
        let temp = noiseAngle * 180 / Math.PI;

        if (this.currentAngle === null)
        {
            this.currentAngle = noiseAngle;
        }

        let diff = (noiseAngle - this.currentAngle) / 20;

        this.currentAngle += diff;

        let noiseVector = { x: Math.sin(this.currentAngle), y: Math.cos(this.currentAngle) };



        this.velocity.x = noiseVector.x;
        this.velocity.y = -noiseVector.y

         // this.velocity.x += alignment.x + cohesion.x + separation.x;
         // this.velocity.y += alignment.y + cohesion.y + separation.y;
         this.velocity = this.normalize(this.velocity, this.speed);





        this.position.x += this.velocity.x;
        this.position.y += this.velocity.y;

        if (this.alpha < 1)
        {
            this.alpha += this.alphaSpeed;
        }

        if (this.alpha > 1)
        {
            this.alpha = 1;
        }


        if ((this.position.x < -117) || (this.position.x > window.innerWidth) || (this.position.y < -117) || (this.position.y > window.innerHeight + 30))
        {
            this.resetPosition();
            this.alpha = 0;
        }
        // else if (this.position.x > window.innerWidth)
        // {
        //     this.position.x = 0;
        //     this.position.y = window.innerHeight - this.position.y;
        // }
        //
        //
        // if (this.position.y < 0)
        // {
        //     this.position.x = window.innerWidth - this.position.x;
        //     this.position.y = window.innerHeight
        // }
        // else if (this.position.y > window.innerHeight)
        // {
        //     this.position.x = window.innerWidth - this.position.x;
        //     this.position.y = 0;
        // }

        this.setPosition();
    }

    resetPosition ()
    {
        this.position.x =  (window.innerWidth / 4) + Math.random() * (window.innerWidth / 2);
        this.position.y = window.innerHeight ;/// 2 + (-100 + Math.random() * 200);
        /*
        let pos = (Math.random() * 3.99) >> 0;

        if (pos == 0) //top
        {
            this.position.x = Math.random() * window.innerWidth
            this.position.y = Math.random() * 20;
        }
        else if (pos == 1) //right
        {
            this.position.x = Math.random() * 20;
            this.position.y = Math.random() * window.innerHeight;
        }
        else if (pos == 2) //bottom
        {
            this.position.x = Math.random() * window.innerWidth
            this.position.y = Math.random() * 20;
        }
        else if (pos == 3) //left
        {
            this.position.x = Math.random() * 20;
            this.position.y = Math.random() * window.innerHeight;
        }*/
    }
    setPosition ()
    {
        this.el.style.left = this.position.x + "px";
        this.el.style.top = this.position.y + "px";

        // if (this.currentAngle !== null)
        // {
        //     this.el.style.transform = `rotate(${this.currentAngle}rad)`;
        // }

        if (this.el.style.opacity !== this.alpha)
        {
            this.el.style.opacity = this.alpha;
        }
    }

     distance(pos1, pos2) {
        return Math.sqrt(Math.pow(pos1.x - pos2.x, 2) + Math.pow(pos1.y - pos2.y, 2));
    }

     normalize(vector, speed) {
        let length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
        if (length > 0) {
            return { x: (vector.x / length) * speed, y: (vector.y / length) * speed };
        }
        return vector;
    }


    static showInCanvas (div, noise)
    {
        //let ctx = canvas.getContext("2d");
        //let noiseValue = noise.noise(window.innerWidth, window.innerHeight);

        let size = Boid.getNoiseScale();
        let width = Math.ceil(window.innerWidth / size);
        let height = Math.ceil(window.innerHeight / size);

        //draw a square for each pixel in the canvas
        for (let x = 0; x < width; x++)
        {
            for (let y = 0; y < height; y++)
            {
                let noiseValue = noise.noise(x, y);

                //the noise value is between 0 and 1, convert to css rgb where 0 is rgb(0,0,0) and 1 is rgb(255,255,255)
                noiseValue = Math.round(noiseValue * 360);

                Boid.showArrow(div, x * size, y * size, noiseValue, size)


                // ctx.fillStyle = `rgba(${noiseValue},${noiseValue},${noiseValue},1)`;
                // ctx.fillRect(x * size, y * size, size, size);
            }
        }

    }

    static showArrow (div, offsetX, offsetY, angle, size)
    {
        //copy an image in the div and position and rotate it
        let img = document.createElement("img");
        img.src = "/images/debug/arrow.png";
        img.style.position = "absolute";
        img.style.left = offsetX + "px";
        img.style.width = size + "px";

        img.style.top = offsetY + "px";
        img.style.transform = `rotate(${angle}deg)`;

        //change opacity to 25%
        img.style.opacity = 0.5;

        div.appendChild(img);

    }

    // Add a method to draw the boid (if using canvas)
}

// Create and animate boids
// let boids = [];
// for (let i = 0; i < 100; i++) {
//     boids.push(new Boid(Math.random() * canvasWidth, Math.random() * canvasHeight));
// }
//
// function animate() {
//     for (let boid of boids) {
//         boid.update(boids);
//         // Draw or update position of boid
//     }
//     requestAnimationFrame(animate);
// }
//
// animate();
